import { render } from "./AddFicheStockPage.vue?vue&type=template&id=17e98553&ts=true"
import script from "./AddFicheStockPage.vue?vue&type=script&lang=ts"
export * from "./AddFicheStockPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__